import { DOCUMENT, Location, ViewportScroller } from '@angular/common';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { AbstractControl, FormGroup, NG_VALUE_ACCESSOR, ValidationErrors } from '@angular/forms';
// import { MatDialog } from '@angular/material/dialog';
// import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject, catchError, timeout } from 'rxjs';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  matDialogRefId!: string;



  profilePic$: Subject<any> = new Subject();
  activeTab$ = new BehaviorSubject<string>('null')
  userDetails$ = new BehaviorSubject<string>('null')
  vendorUserPlan$ = new BehaviorSubject<string>('null')

  matching_Detail_Drawer$ = new BehaviorSubject<boolean>(false)
  filterDrawer$ = new BehaviorSubject<boolean>(false)


  profileSidenav$ = new BehaviorSubject<{ bool: boolean; Info: any }>({
    bool: false, // replace with your default boolean value
    Info: null,  // replace with your default Info value
  });
  addResourceSideNavOpen$= new BehaviorSubject<{ bool: boolean; Info: any }>({
    bool: false, // replace with your default boolean value
    Info: null,  // replace with your default Info value
  });

  aiMatching$ = new BehaviorSubject<boolean>(false)
  matchingResumeInfo$ = new BehaviorSubject<unknown[]>([])
  total_Resource_Count$ = new BehaviorSubject<number>(0)
  preferenceDrawer$ = new BehaviorSubject<boolean>(false)

  progressData = new BehaviorSubject<number>(0);
  showProgressBar = new BehaviorSubject<boolean>(false);
  latterAndResumeProgressBar = new BehaviorSubject<boolean>(false);
  constructor(
    private _router: Router,
    // private _matDialog: MatDialog,
    private _viewPortScroll: ViewportScroller,
    // private _snackBar: MatSnackBar,
    private _location: Location,
    @Inject(DOCUMENT) private _document: any,
    private _http: HttpClient,

  ) { }

  base = environment.session_base_url;

  teamSize = [
    {
      "_id": "6316e02b0e767f53cabdd9b6",
      "data": "5-20"
    },
    {
      "_id": "6316e0400e767f53cabdd9b7",
      "data": "20-100"
    },
    {
      "_id": "6316e0540e767f53cabdd9b8",
      "data": "100-200"
    },
    {
      "_id": "6316e06a0e767f53cabdd9b9",
      "data": "200+"
    }
  ]

  // premiumPlanPaid(jobId: string, payload: any) {
  //   return this._http.post(`${this.base}vendors/vendor-apply-for-premium`, payload).pipe(timeout(75000), catchError((error: HttpErrorResponse) => {
  //     throw error;
  //   }));
  // }
  // Latest start
  //validate email
  validateEmail(emailControl: any) {
    const regExp = new RegExp(
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    )
    if (!regExp.test(emailControl.value)) {
      return { validateEmail: true }
    }
    return null
  }

  /**
  * Function to convert bytes to readable string
  * @param value Bytes
  * @returns String
  */
  convertBytes(value: any): string {
    if (value / 1000 < 1000) {
      return Math.floor(+value / 1000) + ' KB';
    } else {
      return Math.floor(+value / 1000000) + ' MB';
    }
  }
  // getExperienceRange(experienceData: string): string {
  //   const range = experienceData.split('-');

  //   if (range.length === 2) {
  //     return range[0] + ' to ' + range[1] + ' years of Experience';
  //   } else if (experienceData.includes('+')) {
  //     return experienceData + ' years of Experience';
  //   }

  //   return experienceData;
  // }


  // getExperienceRange(experienceData: string): string {
  //   const range = experienceData.split('-');

  //   if (range.length === 2) {
  //     return range[0] + ' to ' + range[1] + ' years of Experience';
  //   }
  //   return experienceData;
  // }


  // removeNullorEmptyInterview
  // removeNullorEmptyInterview(skillsArray: any) {
  //   // if(skillsArray){
  //   const filteredArray = skillsArray?.filter((item: any) => item.round_name !== undefined && item.round_name !== null && item.round_name !== "");
  //   return filteredArray
  //   // }
  // }

  //Scroll animation
  scrollTo(el: Element): void {
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  }

  // scroll to the error
  scrollToError(): void {
    const firstElementWithError: any = document.querySelector('.ng-invalid[formControlName]');
    this.scrollTo(firstElementWithError);
  }






  // Latest End





  /**
   * Function to open material snackbar with message and action
   * @param message `string` Message to show in material snackbar
   * @param action `string` Action to perform with button in material snackbar
   */
  // openSnackBar(message: string, action?: string, duration?: number): void {
  //   this._snackBar.open(message, action || 'Dismiss', { panelClass: 'snack-bar', duration });
  // }

  /**
   * Remove spaces from end of form control's value
   * @param {AbstractControl} control Form control whose value must be trimmed
   */
  removeSpacesFromInput(control: AbstractControl): void {
    if (control.value?.length)
      control.setValue(control.value.trim());
  }

  /**
   * Scroll to the top of the page
   */
  scrollToTop(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  /**
   * Function to scroll to particular html element and set fragment to url
   * @param id CSS id of html element
   */
  scrollToElement(id: string): void {
    this._router.navigate([], {
      fragment: id
    });
    this._viewPortScroll.scrollToAnchor(id);
  }

  /**
   * Function to allow only numbers in input field
   * @param event Key event
   * @returns True if number is input
   */
  numberOnly(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    const allowedKey = [8, 9, 17, 37, 38, 39, 40, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
    if (allowedKey.includes(charCode)) {
      return true;
    } else {
      return false;
    }
  }


  /**
   * Function to allow only numbers in input field
   * @param event Key event
   * @returns True if number is input
   */
  numberOnlyForMonth(event: any) {
    const charCode = event.which ? event.which : event.keyCode;
    const allowedKey = [8, 9, 17, 37, 38, 39, 40, 46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105];
    if (allowedKey.includes(charCode)) {
      return true;
    } else {
      return false;
    }
  }


  /**
   * Function to allow only alphabet in input field
   * @param event Key event
   * @returns True if alphabet is input
   */
  alphabetOnly(event: any) {
    var regex = new RegExp("^[a-zA-Z ._\b\t]+$");
    var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
    if (!regex.test(key)) {
      event.preventDefault();
      return false;
    } else {
      return true
    }
  }

  /**
   * Function to add commas to number value
   * @param event Input event
   * @param formControl Form control whose value is to be changed
   */
  addCommas(event: any, formControl: AbstractControl): void {
    let value = event.target ? event.target.value.toString().replace(/,/g, '') : event.toString().replace(/,/g, '');
    if (!(+value)) {
      return;
    }
    formControl.setValue((+value).toLocaleString('en-IN'));
  }

  /**
   * Function to convert string to base64 encoded string
   * @param stringText Value to encode
   * @returns `encoded string`
   */
  base64Encode(stringText: any): string {
    return window.btoa(stringText);
  }

  /**
   * Function to convert base64 encoded string to normal string
   * @param stringText Type: base64 encoded string
   * @returns `decoded string`
   */
  base64Decode(stringText: any): string {

    return window.atob(stringText);
  }

  /**
   * Redirects to input url
   * @param uri Target absolute url
   */
  redirectTo(uri: string): void {
    this._router.navigateByUrl('/redirect', { skipLocationChange: true }).then(() =>
      this._router.navigate([uri])
    );
  }

  /**
   * Function that uses window.location.href to redirect to provided url
   * @param url URL for redirection
   */
  locationRedirect(url: string): void {
    window.location.href = url;
  }

  /**
   * Checks if user is browsing in PC or Mobile devices
   * @returns `True` - if user is browsing in PC device
   * @returns `False` - if user is browsing in Mobile device
   */
  checkIfWebUser(): boolean {
    if (navigator.userAgent.match(/Android/i)
      || navigator.userAgent.match(/webOS/i)
      || navigator.userAgent.match(/iPhone/i)
      || navigator.userAgent.match(/iPad/i)
      || navigator.userAgent.match(/iPod/i)
      || navigator.userAgent.match(/BlackBerry/i)
      || navigator.userAgent.match(/Windows Phone/i)) {
      return false;
    } else {
      return true;
    }
  }
  /**
   * Creates {@link Object} hard copy
   * @param data Object to copy
   * @returns Hard copy of input object
   */
  createObjCopy(data: any): any {
    return JSON.parse(JSON.stringify(data));
  }

  /**
   * Function to open Material Dialog Box
   * @param template Angular component that should behave as a dialog box
   * @param data Data that needs to be injected into dialog box component
   */
  // openDialogBox(template: any, data?: any) {
  //   this.closeDialogBox();
  //   const dialogRef = this._matDialog.open(template, { panelClass: 'custom-dialog', data: data, hasBackdrop: false });
  //   this.matDialogRefId = dialogRef?.id;
  //   return dialogRef;
  // }

  /**
   * Closes all Popups that are currently in open state
   */
  // closeDialogBox(): void {
  //   this._matDialog.closeAll();
  // }

  /**
   * Function that waits for some time before hiding the dialog box
   * @param {number} delay Time to delay in milliseconds
   * @param {string} url Destination route url
   */
  autoHideDialogBox(delay: number, url?: string, dialogRef?: any): void {
    setTimeout(() => {
      if (dialogRef?.id == this.matDialogRefId) {
        // this.closeDialogBox();
        if (url?.trim() != '') {
          this._router.navigate([url]);
        }
      }
    }, delay);
  }

  /**
   * Clears outs query params from URL
   * @param {string} args `String` Query param string to be removed from url
   */
  clearQueryParams(...args: Array<string>): void {

    let data = Object.assign({});
    args.forEach((element: string) => {
      data[element] = null;
    });

    this._router.navigate([], {
      queryParams: data,
      queryParamsHandling: 'merge'
    });
  }

  /**
   * Function to set queryParams in URL with merge as queryParams handling
   * @param data Data with key value pairs to be set as queryParams in URL
   */
  addQueryParamsToUrl(data: any): void {
    this._router.navigate([], {
      queryParams: data,
      queryParamsHandling: 'merge'
    });
  }

  /**
   * Function that takes file url and returns the file name
   * @param fileName File url in string
   * @returns Decoded file name from url
   */
  resumeFileName(fileName: string): string {
    let name: Array<any> = fileName.split('_');
    name.splice(0, 1);
    return decodeURIComponent(name.join('_'));
  }


  /**
   * Function that takes object and returns the object in query params structure
   * @param queryParams Object of queryParams
   * @returns queryParams structured for URL
   */
  returnQueryParams(queryParams: any): string {

    let query = "";
    if (queryParams) {
      var esc = encodeURIComponent;
      query += Object.keys(queryParams)
        .map(k => esc(k) + '=' + esc(queryParams[k]))
        .join('&');
    }
    return query != "" ? "?" + query : "";
  }

  /**
   * Function to calculate Difference in dates
   * @param end End Date of type `Date`
   * @param start Start Date of type `Date`
   * @returns Difference in String format (ex: - 1 year 3 months)
   */
  calculateDateDifference(end: any, start: any): any {

    let months = Math.floor((end - start) / (1000 * 60 * 60 * 24 * 30));
    if (months % 12 == 0) {
      return Math.floor(months / 12) + (Math.floor(months / 12) > 1 ? ' years ' : ' year ');
    } else if (months > 12) {
      return Math.floor(months / 12) + (Math.floor(months / 12) > 1 ? ' years ' : ' year ') + (months % 12) + (months % 12 > 1 ? ' months' : ' month');
    } else {
      return months + ' months';
    }
  }

  /**
   * Function that calculates average of numbers
   * @param args Numbers separated with comma
   * @return Average of numbers provided
   */
  calculateAverage(...args: Array<number>): any {
    return (args.reduce((partialSum, current) => partialSum + current, 0) / args.length).toFixed(1);
  }

  /**
   * Function to shuffle array elements
   * @param array Array to shuffle
   * @returns Shuffled array
   */
  shuffleArrayElements(array: Array<any>): Array<any> {
    let currentIndex = array.length, randomIndex;

    // While there remain elements to shuffle.
    while (currentIndex != 0) {

      // Pick a remaining element.
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [array[randomIndex], array[currentIndex]];
    }
    return array;
  }
  /**
   * Function to delete null/empty keys from an object
   * @param data type `Object`
   * @returns `Object`
   */
  deleteNullKeysInObject(data: any) {
    Object.keys(data).map(function (key) {
      if (data[key] == null || data[key] == 'null' || data[key] == undefined || data[key] == "") {
        delete data[key];
      }
    });
    return data;
  }
  deleteUndifindKeysInObject(data: any) {
    Object.keys(data).map(function (key) {
      if (data[key] == null || data[key] == 'null' || data[key] == undefined || (typeof data[key] == 'string' && data[key] == '')) {
        delete data[key];
      };
    });
    return data;
  }

  /**
   * Function to delete null/empty keys from an object
   * @param data type `Object`
   * @returns `Object`
   */
  removeNull = (obj: any) => {
    Object.keys(obj).forEach((key: any) => {
      if (key != 'primarySkills') {
        (obj[key] && typeof obj[key] === 'object') && this.removeNull(obj[key]) ||
          (obj[key] === undefined || obj[key] === null) && delete obj[key]
      }
    });
    return obj;
  };

  /**
   * Function that copies value to user's clipboard
   * @param value Value to copy to clipboard
   */
  // async copyToClipboard(value: any) {
  //   try {
  //     await navigator.clipboard.writeText(value);
  //     this.openSnackBar('Copied to clipboard!!', 'Dismiss', 500);
  //   } catch (error: any) {
  //     this.openSnackBar(error?.error?.message || '', 'Dismiss', 500);
  //   }
  // }

  /**
   * Hides header on navigation when links are accessed from navbar in mobile devices
   */
  removeClassFromHeader(): void {
    let header = this._document.querySelector('.slideMenu-slider') as HTMLElement;
    // close header if open
    if (header && header.classList.contains('open')) {
      header.classList.remove('open');
    }
  }

  /**
   * Creates html meta tag
   * <meta name="robots" content="noindex, nofollow">
   */
  createRobotsMetaTag(): void {
    let meta: HTMLLinkElement = this._document.createElement('meta');
    meta.setAttribute('name', 'robots');
    meta.setAttribute('content', 'noindex, nofollow');
    this._document.head.appendChild(meta);
  }

  /**
   * Removes meta tag
   * <meta name="robots" content="noindex, nofollow">
   */
  removeRobotsMetaTag(): void {
    const robots: any = this._document.querySelectorAll('meta[content="noindex, nofollow"]');
    robots[0].parentElement.removeChild(robots[0]);
  }

  /**
   * Function that checks current status of user from a list of completed steps
   * @param statusList List of completed statuses
   * @returns String
   */
  checkCurrentStatus(statusList: Array<any>): string {
    let statusArray = statusList.map((x: any) => x?.status_name);
    if (statusArray.includes('vetted')) {
      return 'vetted';
    } else if (statusArray.includes('rejected')) {
      return 'rejected';
    } else if (statusArray.includes('skill-test-completed')) {
      return 'skill-test-completed';
    } else if (statusArray.includes('skill-test-re-link-shared')) {
      return 'skill-test-re-link-shared';
    } else if (statusArray.includes('skill-test-link-shared')) {
      return 'skill-test-link-shared';
    } else if (statusArray.includes('completed-intro-video')) {
      return 'completed-intro-video';
    } else if (statusArray.includes('completed-work-survey')) {
      return 'completed-work-survey';
    } else if (statusArray.includes('profile-completed')) {
      return 'profile-completed';
    } else {
      return 'Draft';
    }
  }

  /**
   * Function to generate random value within provided range
   * @param min Minimum value in range
   * @param max Maximum value in range
   */
  generateRandomNumber(min: number, max: number): number {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  /**
   * Function to redirect user to previous visited url
   */
  navigateBack(): void {
    this._location.back();
  }

  /**
   * Function to open linkedin url in new tab
   * @param url Linkedin profile URL
   */
  openUrlInNewTab(url: string): void {
    if (!url.includes('https') && !url.includes('http')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank');
  }



  /**
   * Function to check id is in the array
   * @param array List of jobs
   * @param value id to check
   * @returns boolean
   */
  checkIdIsInArray(value: any, array: any): boolean {
    const isFound = array.some((element: any) => {
      if (element.project_id == value) {
        return true;
      }
      return false;
    });
    return isFound;
  }

  /**
   * Function to check id is in the array
   * @param value jobId to check
   * @param array Handpicked Job Ids array
   * @returns boolean
   */
  isTopMachingJob(value: any, array: any): boolean {
    const isFound = array.some((element: any) => {
      if (element == value) {
        return true;
      }
      return false;
    });
    return isFound;
  }

  /**
   * Function to create hubspot script tag
   */
  createHubspotScript(): void {
    if (environment.production) {

      let script = document.createElement('script');

      script.async = true;
      script.defer = true;
      script.src = 'https://js.hs-scripts.com/21484450.js';
      script.type = "text/javascript";
      script.id = "hs-script-loader";

      document.body.appendChild(script);
    }
  }

  /**
   * Function to delete hubspot script tag along with its iframe tag
   */
  deleteHubspotScript(): void {
    if (environment.production) {
      let script = document.getElementById('hs-script-loader');
      let iframe = document.getElementById('hubspot-messages-iframe-container');
      iframe?.parentNode?.removeChild(iframe);
      script?.parentNode?.removeChild(script);
    }
  }
  removeEmptyStrings(obj: any) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === '' || obj[key] == null || obj[key] == undefined) {
        delete obj[key];
      }
    }
    return obj
  }



  /**
  * Function removed if zero after decimal
  */
  removedZeroAfterDecimal(value: any): void {
    if (value % 1 === 0) {
      let integerNumber: any = Math.floor(value)
      return integerNumber
    } else {
      return value
    }
  }







  public findMatchedPreference(travelPreference: string): any {
    let preference = [
      {
        "_id": "638df1c4fa031d4ec023f3d2",
        "data": "Remote"
      },
      {
        "_id": "638df2cafa031d4ec023f3d5",
        "data": "On-site"
      },
      {
        "_id": "638df2d4fa031d4ec023f3d7",
        "data": "Hybrid"
      }
    ]
    const preferenceArray = Object.values(preference);
    return preferenceArray.find(pref => pref._id === travelPreference);
  }



  public findMatchedEngagementType(jobType: string): any {
    let engagement_type = [
      {
        "_id": "63105f7d61108404f9b18fe1",
        "data": "Full-Time Contract"
      },
      {
        "_id": "63105f9f61108404f9b18fe2",
        "data": "Part-Time"
      },
      {
        "_id": "63105fbf61108404f9b18fe3",
        "data": "Permanent"
      }
    ]

    const engagementTypeArray = Object.values(engagement_type);
    return engagementTypeArray.find(pref => pref._id === jobType);
  }

  public findMatchedHiringType(jobType: string): any {

    let hiring_type = [
      {
      "_id": "6634b12b46acb34dc835f353",
      "data": "Contractual"
    },
    {
      "_id": "6634b12b46acb34dc835f354",
      "data": "C2H"
    },
    {
      "_id": "6634b12b46acb34dc835f355",
      "data": "FTE"
    }]
    const hiringTypeArray = Object.values(hiring_type);
    return hiringTypeArray.find(pref => pref._id === jobType);
  }


  transformSkills(skills: any[]): any[] {

    return skills?.map(item => ({
      "_id": item._id,
      "skill": item?.skill || 'na'
    })) || [];

  }
  getSkillId(skills: any[]): string {
    return (skills || []).map(skill => skill?._id).join(',');
  }

  getCommaSeparatedIds(items: any[], property: string): string {
    return items
      ?.map((item: any) => item?.[property])
      ?.filter((id: any) => id !== undefined && id !== null)
      ?.join(',');
  }

  filterAndMapByIds(items: any[], selectedIds: string[] | undefined): any[] {
    return items
      ?.filter((item: any) => selectedIds?.includes(item?._id))
      ?.map((item: any) => item) || [];
  }


  getIdsStringFromArray(items: any[]): string {
    return items.map((item: any) => item?._id).join(',');
  }



  patchFormValues(formGroup: FormGroup, values: { [key: string]: any }): void {
    Object.keys(values).forEach((controlName: string) => {
      if (formGroup.controls[controlName]) {
        formGroup.patchValue({ [controlName]: values[controlName] });
      }
    });
  }

  // user details
  getVendorUserPlan() {
    this.vendorUserPlan$.subscribe((response: any) => {
      if (response) {

        response;
      }
    })

  }


  /**
   * Function to get progress of api call
   * @param event {@link HttpEvent} Event from api call
   */
  updateProgressData(event: any): void {
    if (event?.type == 1) {
      let percentage = (event?.loaded * 100) / event?.total;
      this.progressData.next(percentage);
    }
  }
  updateProgressForMultiData(event: any): void {
    if (event?.type != 0) {
      let percentage = (event?.loaded * 100) / event?.total;
      this.progressData.next(percentage);
    }
  }

 // for preventing user to start typing by space

  preventLeadingSpace(event: KeyboardEvent): void {
    const inputField = event.target as HTMLInputElement;
    if (event.key === ' ' && inputField.value.length === 0) {
      event.preventDefault();
    }
  }
    getFirstLetters(str: any) {
    let firstLetters;
    if (str != null) {
      firstLetters = str
        .split(' ')
        .map((word: any) => word.charAt(0))
        .join('');
    }
    if (firstLetters?.length > 2) {
      return firstLetters.substring(0, 2);
    }
    return firstLetters;
  }
}




